import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const InscriptionPage = lazy(() => import('../pages/inscription/page'));
const RegistrationPage = lazy(() => import('../pages/registration/page'));
const RegistrationSuccessPage = lazy(() => import('../pages/registration-success/page'));
const ReservationMentoratPage = lazy(() => import('../pages/reservation-mentorat/page'));
const ChatVocalPage = lazy(() => import('../pages/chat-vocal/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const RulesPage = lazy(() => import('../pages/rules/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const AllProjectsPage = lazy(() => import('../pages/all-projects/page'));
const ResultsPage = lazy(() => import('../pages/results/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AdminTimerPage = lazy(() => import('../pages/admin-timer/page'));
const AdminProjectsPage = lazy(() => import('../pages/admin-projects/page'));
const AdminCallsPage = lazy(() => import('../pages/admin-calls/page'));
const AdminLoginPage = lazy(() => import('../pages/admin-login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin-dashboard/page'));
const AdminAudioMessagesPage = lazy(() => import('../pages/admin-dashboard/AdminAudioMessagesPage'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/comment-ca-marche',
    element: <HowItWorksPage />,
  },
  {
    path: '/connexion',
    element: <LoginPage />,
  },
  {
    path: '/inscription',
    element: <InscriptionPage />,
  },
  {
    path: '/inscription-reussie',
    element: <RegistrationSuccessPage />,
  },
  {
    path: '/registration',
    element: <RegistrationPage />,
  },
  {
    path: '/registration-success',
    element: <RegistrationSuccessPage />,
  },
  {
    path: '/reservation-mentorat',
    element: <ReservationMentoratPage />,
  },
  {
    path: '/chat-vocal',
    element: <ChatVocalPage />,
  },
  {
    path: '/projets',
    element: <ProjectsPage />,
  },
  {
    path: '/tous-les-projets',
    element: <AllProjectsPage />,
  },
  {
    path: '/resultats',
    element: <ResultsPage />,
  },
  {
    path: '/politique-confidentialite',
    element: <PrivacyPage />,
  },
  {
    path: '/conditions',
    element: <TermsPage />,
  },
  {
    path: '/reglement',
    element: <RulesPage />,
  },
  {
    path: '/admin-timer',
    element: <AdminTimerPage />,
  },
  {
    path: '/admin-projects',
    element: <AdminProjectsPage />,
  },
  {
    path: '/admin-calls',
    element: <AdminCallsPage />,
  },
  {
    path: '/admin-audio-messages',
    element: <AdminAudioMessagesPage />,
  },
  {
    path: '/admin-login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin-dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
